/**
 * Canonical gate for the Product Hierarchy module.
 *
 * Resolves Entitlement → Workspace module → Module policy → Personal flag via
 * the one policy-aware gate (build contract §2.7). Never check
 * isModuleEnabled/isFeatureEnabled inline for product-tree surfaces — use this.
 */

import { useModuleGate } from '../../../lib/moduleGate';

export function useProductHierarchyEnabled(): boolean {
  return useModuleGate('product_hierarchy');
}
